
export const baseUrl = "https://gallery-mart.ru/";
// export const baseUrl = "http://api/";
